// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1bT5v","switch":"ToggleSwitch_switch__3WR_g"};